"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var response = function response(ctx) {
  var params = ctx.req.params || {};
  var resp = ctx.res.data;

  // 控制跳转的逻辑
  if (params.autoHandleRedirect && resp && resp.redirect && resp.url) {
    window.location.href = resp.url;
  }

  return ctx;
};

exports.default = { response: response };